import * as Helpers from '../helpers'
export default function Button({onClick, children, type ='default', className}) {
    return <button className={Helpers.classNames(`button button-${type}`, className)} onClick={onClick}>{children}</button>
}
